export default __webpack_public_path__ + "static/media/facebook.24385598.png";